module.exports = __webpack_public_path__ + "b5d2ac099016fe5a536e819c51e9c4b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/twitter_2021_chart.png
// module id = 1752
// module chunks = 0